<script lang="ts">
  import {getContext} from 'svelte';
  import lang from '../LoginPage.lang';

  export let LG = getContext("LG");
  enum TabType {
    Email,
    Qrcode
  }
  let selectedType = TabType.Email;

  function handleTabSelectFun(type: TabType){
    return function(){
      selectedType = type;
    }
  }
</script>

<style lang="scss">
  .tab {
    color: #999B9F;
    border-bottom: 1px solid #DCDFE5;
    height: 38px;
    &.gap-32{
      gap: 32px;
    }
    .selected{
      color: #1D2029;
      font-weight: 500;
      border-bottom: 2px solid #000;
    }
  }
</style>


<div class="mt24 df tab gap-32 f16">
  <div class="lh22 cp" class:selected={selectedType === TabType.Email} on:click|stopPropagation={handleTabSelectFun(TabType.Email)}>{LG(lang.Email)}/{LG(lang.SubAccount)}</div>
  <div class="lh22 cp wsn" class:selected={selectedType === TabType.Qrcode} on:click|stopPropagation={handleTabSelectFun(TabType.Qrcode)}>{LG(lang.QrCodeTab)}</div>
</div>
<div>
  {#if selectedType === TabType.Email}
    <div class:hide={true}>
      <slot name='email-login'/>
    </div>
  {/if}
  {#if selectedType === TabType.Qrcode}
    <slot name='qrcode-login'/>
  {/if}
</div>
